import { defineMessages } from 'react-intl'


export default defineMessages({
  purposesAndSpecialFeatures: {
    defaultMessage: '<b>We process data for the following purposes and special features:</b> {list}.',
    id: 'tcf-consent-message.purposes-and-special-features',
  },
})
